import { SET_ACCEPT_AGREEMENT_START, SET_ACCEPT_AGREEMENT_FULFILLED, SET_ACCEPT_AGREEMENT_REJECTED } from './actionTypes';

const initialState = {
  isLoading: false,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCEPT_AGREEMENT_START:
      return {
        ...state,
        isLoading: true,
      };
    case SET_ACCEPT_AGREEMENT_FULFILLED:
      return {
        ...state,
        isLoading: false,
      };
    case SET_ACCEPT_AGREEMENT_REJECTED:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
}
